import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const AlertBox = styled.div`
    position: relative;
    width: 556px;
    height: 346px;
    border-radius: 8px;
    border: 1px solid var(--light-vermelho-light, #4BBFEF);
    background: #FFF1E8;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`
export const AlertTitle = styled.h2`
    color: #4BBFEF;
    text-align: center;
    font-family: Poppins;
    font-size: 26px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px;
`;

export const AlertSubtitle = styled.p`
    color: #000000; /* Ajuste a cor conforme desejado */
    text-align: center;
    font-family: Poppins, sans-serif;
    font-size: 14px;
    // font-weight: 400; /* Regular */
    line-height: 24px;
    margin-top: 10px; /* Espaçamento entre o título e a legenda */
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 20px;
`;

export const NoButton = styled.button`
  width: 65px;
  height: 45px;
  background-color: #EE3B5E;
  border: 1px solid var(--light-vermelho-light, #E02E1A);
  border-radius: 8px;
  font-family: Poppins, sans-serif;
  font-size: 14px;
  font-weight: 300;
  color: #ffffff;
  cursor: pointer;
  &:hover {
    background-color: #EE3B5E;
  }
`;

export const YesButton = styled.button`
  width: 65px;
  height: 45px;
  background-color: #4BBFEF;
  border: 1px solid var(--light-vermelho-light, #0090CE);
  border-radius: 8px;
  font-family: Poppins, sans-serif;
  font-size: 14px;
  font-weight: 300;
  color: #ffffff;
  cursor: pointer;
  &:hover {
    background-color: #4BBFEF;
  }
`;